export default "__VITE_ASSET__Cwa6DZsm__"